<template>
    <div>
        <div class="grid grid-cols-12 gap-6">
            <div class="hidden md:col-span-1 md:block" />
            <div class="col-span-12 text-left md:col-span-10">
                <div class="mb-10 flex justify-between md:justify-around">
                    <h2
                        class="cursor-pointer text-[#002793]"
                        :class="
                            activeTab === 'ulice'
                                ? 'underline'
                                : 'text-[#002793]'
                        "
                        @click="activeTab = 'ulice'"
                    >
                        Abecední seznam ulic
                    </h2>
                    <h2
                        class="cursor-pointer text-[#002793]"
                        :class="
                            activeTab === 'hesla'
                                ? 'underline'
                                : 'text-[#002793]'
                        "
                        @click="activeTab = 'hesla'"
                    >
                        Seznam souborných hesel
                    </h2>
                </div>

                <AbecedniSeznamUlic v-if="activeTab === 'ulice'" />
                <SouborneHesloSeznam v-if="activeTab === 'hesla'" />

                <AppFooter />
            </div>
            <div class="hidden md:col-span-1 md:block" />
        </div>

        <!-- <AppFooter /> -->
    </div>
</template>

<script setup lang="ts">
const activeTab = ref("ulice")
</script>

<style scoped></style>
